export default "__VITE_ASSET__DMhZu4JE__"